import React, { useState } from "react";
import { useEffect } from "react";
import "../../Assets/css/LifeInsurance/ProductDetailPage.css";

import { useNavigate, useParams } from "react-router";
import Axios from "axios";
import { Card, Paper } from "@mui/material";
import DocumentsNeeded from '../../HealthInsurance/PolicyHighlightPage/DocumentsNeeded';
import PdfDocuments from "../../HealthInsurance/PolicyHighlightPage/PdfDocuments";
import Highlights from "../../HealthInsurance/PolicyHighlightPage/Highlights";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Acurightlogo from '../../Assets/images/Acurightlogo.PNG';
import Acuvisorlogo from '../../Assets/images/Acuvisorlogo.PNG';
//import SRimg from '../../ShriramImage/SRimg.jpg'

function ProductDetailsPage(props) {
  const [transferData, setTransferData] = useState({})
  const [ProductDetails, setProductDetails] = useState({})
  const [acuviserProductDetail, setAcuviserProductDetail] = useState({});
  const [videoUrl, setVideoUrl] = useState('')


  const navigate = useNavigate();
  const { id } = useParams();
  const productIdArray = id.split('*')
  const transId = productIdArray[0]
  const Acuvisor_product_id = productIdArray[1]

  useEffect(() => {
    // setProductDetails(shriQuick);

    let formdata = new FormData();
    formdata.append("policy_product_id", Acuvisor_product_id);
    console.log('form Data', formdata)


    Axios.post('https://dev.acuvisor.com/App2/Application/get_policydetal/', formdata, {

      headers: {
        "Authorization": "Basic VC0sLDlfZDYzWUdZSWM4NyheNTpSbjcyXjhZS3FSaXA4dl5hI3w=",
      }

    }).then((res) => {
      console.log('php', res)
      let videoUrlArray;
      if (res.status === 200) {
        setAcuviserProductDetail(res.data[0])


        videoUrlArray = res.data[0].video_url.split('/')
        console.log('kkk', videoUrlArray[videoUrlArray.length - 1].includes('watch'))
        if (videoUrlArray[videoUrlArray.length - 1].includes('watch')) {
          let splitWatch = videoUrlArray[videoUrlArray.length - 1].split('=')
          setVideoUrl(splitWatch[splitWatch.length - 1])
        } else {
          setVideoUrl(videoUrlArray[videoUrlArray.length - 1])
        }

      }
    })

    let domain = '';

    if (window.location.hostname === 'localhost') {
      domain = process.env.REACT_APP_LOCAL_DJANGO
      
    }else if (window.location.hostname.trim() === "acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO

    }else{
      domain = process.env.REACT_APP_UAT_DJANGO
     
    }

    Axios.get(
      `${domain}/api/shriram/plp-validate-response/${transId}`
      //`http://ec2-43-205-26-216.ap-south-1.compute.amazonaws.com/api/shriram/plp-validate-response/${id}`
    ).then(
      (response) => {
        if (response.status === 200) {
          console.log("response from py", response);
          setProductDetails(response.data);
          // setProductDetails(response.data);
        }
      }
    );
   
  }, []);

  console.log(id, "PHP");
  const buyPlanHandler = () => {

    navigate(`/life-insurance/validateproposal/${ProductDetails.vp_config_id}*${transId}`);
  };

  const arrowBackHandler = () => {
    navigate(-1);
  }

  return (
    <>
      {
        Object.keys(ProductDetails).length > 0 && Object.keys(acuviserProductDetail).length > 0 ?
          <div className="detailpage">
            <div >
            <Paper className="detailpage_header">
              <div className="header_img">
                <ArrowBackIcon style={{ cursor: 'pointer' }} onClick={() => arrowBackHandler()}></ArrowBackIcon>
              </div>
              <div className="header_img">
                <img src={Acuvisorlogo} />
              </div>
              <div className="header_img">
                <img src={Acurightlogo} />
              </div>
            </Paper>
            <Card style={{ backgroundColor: "#0c409a", color: "white", padding: 20 }}>
              <div className="pro_heading">
                <div className="pro_image">
                  <img className="bg-white img-thumbnail rounded" src={acuviserProductDetail.company_logo} />
                </div>
                <div>
                  <div className="text-capitalize">{acuviserProductDetail.policy_name} - {/* {quickQuoteDetails.coverType} */}</div>
                  <div>{acuviserProductDetail.company_name} {/* - {quickQuoteDetails.coverType} */}</div>

                </div>
              </div>
              <div className="details_container">
                <div>
                  <div>
                    <div>Sum Assured</div>
                    <div>&#8377; {ProductDetails.SumProposed}</div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Premium Amount</div>
                    <div>&#8377; {ProductDetails.TotalPremium}</div>
                  </div>
                </div>
                <div className="linewithdata">
                  <div className="line"></div>
                  <div>
                    <div>Term</div>
                    <div>{ProductDetails.PremiumFrequencyString}</div>
                  </div>
                </div>
              </div>

            </Card>
            <div>
              <p style={{ marginLeft: 20, marginTop: 20, fontSize: 20 }}>
                {acuviserProductDetail.company_name}
              </p>
              <iframe id="video_url"
                src={`https://www.youtube.com/embed/${videoUrl}`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="video"
              />
            </div>

            <Card className="id_container">
              <div style={{ marginLeft: 20, marginTop: 20 }}>
                Document Needed
              </div>
              <DocumentsNeeded
                doc1={acuviserProductDetail.document1}
                doc2={acuviserProductDetail.document2}
                doc3={acuviserProductDetail.document3}
                doc4={acuviserProductDetail.document4}
              />
              {/* <div className="id_grid">
                            <div className='ids'>
                                <CheckCircleIcon style={{ color: "#18c6b1" }} />
                                Kyc-pan Card
                            </div>
                            <div className="ids">
                                <CheckCircleIcon style={{ color: "#18c6b1" }} />
                                Aadhaar Card
                            </div>
                            <div className="ids">
                                <CheckCircleIcon style={{ color: "#18c6b1" }} />
                                Passport
                            </div>
                        </div> */}

            </Card>

            <div className="pdf_container">
              <PdfDocuments
                doc1={acuviserProductDetail.document_pdf1}
                doc2={acuviserProductDetail.document_pdf2}
                doc3={acuviserProductDetail.document_pdf3}
                doc4={acuviserProductDetail.document_pdf4}
                doc5={acuviserProductDetail.document_pdf5}
                docName1={acuviserProductDetail.document_pdfname1}
                docName2={acuviserProductDetail.document_pdfname2}
                docName3={acuviserProductDetail.document_pdfname3}
                docName4={acuviserProductDetail.document_pdfname4}
                docName5={acuviserProductDetail.document_pdfname5}
              />
            </div>

            <div className="accor_container">
              <p style={{ marginLeft: 20, marginTop: 20 }}>
                Policy Highlight
              </p>
              <Highlights
                highlights={acuviserProductDetail.highlight}
              />
            </div>
            </div>


            <div className="btn-sec position-fixed bottom-0 ">
              <button className="Goback_btn text-capitalize" onClick={() => arrowBackHandler()}>Go back</button>
              <button className="submitBtn text-capitalize" onClick={() => buyPlanHandler()}>buy plan</button>
            </div>
          </div>
          : <h3>Please wait</h3>

      }
    </>

  );

  
}


export default ProductDetailsPage;